
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/resources/record-retention-requirements",
      function () {
        return require("private-next-pages/compliance/resources/record-retention-requirements.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/resources/record-retention-requirements"])
      });
    }
  